/*
  BRS sticky buy bar (mobile). Slides in once the real Add to cart button has
  been scrolled past, mirrors its label and state (so the size guard still
  applies), and a tap either submits the real form or jumps to the size pills.
*/
if (!customElements.get('brs-sticky-atc')) {
  customElements.define(
    'brs-sticky-atc',
    class BrsStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.realButton = document.getElementById('ProductSubmitButton-' + this.sectionId);
        this.button = this.querySelector('[data-sticky-submit]');
        this.label = this.querySelector('[data-sticky-label]');
        this.price = this.querySelector('[data-sticky-price]');
        if (!this.realButton || !this.button) return;

        this.sync = this.sync.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.ticking = false;

        this.button.addEventListener('click', () => {
          if (this.realButton.disabled) {
            const guard = document.querySelector('fieldset.product-form__input--brs-size') || this.realButton;
            guard.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          this.realButton.click();
        });

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });

        this.mo = new MutationObserver(this.sync);
        this.mo.observe(this.realButton, { attributes: true, childList: true, subtree: true, characterData: true });
        const priceSource = document.getElementById('price-' + this.sectionId);
        if (priceSource) {
          this.priceMo = new MutationObserver(this.sync);
          this.priceMo.observe(priceSource, { childList: true, subtree: true, characterData: true });
        }
        this.sync();
        this.onScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        this.mo && this.mo.disconnect();
        this.priceMo && this.priceMo.disconnect();
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          const rect = this.realButton.getBoundingClientRect();
          const passed = rect.bottom < 0; // the real button is above the viewport
          this.classList.toggle('is-visible', passed);
          this.setAttribute('aria-hidden', passed ? 'false' : 'true');
        });
      }

      sync() {
        const text = (this.realButton.querySelector('span') || this.realButton).textContent.trim();
        if (this.label) this.label.textContent = text;
        // Never actually disable the sticky button: a tap while a size is missing scrolls to the pills.
        this.button.disabled = false;
        this.classList.toggle('is-disabled', this.realButton.disabled);
        const priceSource = document.querySelector('#price-' + this.sectionId + ' .price-item--sale, #price-' + this.sectionId + ' .price-item--regular');
        if (priceSource && this.price) this.price.textContent = priceSource.textContent.trim();
      }
    }
  );
}
